// extracted by mini-css-extract-plugin
export var activeFilterButton = "_oh-c";
export var backButton = "_oh-4";
export var backIcon = "_oh-5";
export var chevronShortcut = "_oh-6";
export var container = "_oh-1";
export var editor = "_oh-8";
export var editorWrapper = "_oh-7";
export var prefix = "_oh-2";
export var searchIcon = "_oh-3";
export var suffix = "_oh-9";
export var suffixContent = "_oh-a";
export var suffixText = "_oh-b";
export var wrapper = "_oh-0";